module.exports = __webpack_public_path__ + "static/cliente2-966aed6ca8c6182619d835c6af3054c2.png";